export default "__VITE_ASSET__i36CftvW__"